export default "__VITE_ASSET__BKrJh0Lp__"